import React from 'react';
import {useAbility} from '~/lib/ability';
import {RootAbility} from '~/root_ability';
import {ImpersonatedResourceSwitcher} from './ImpersonatedResourceSwitcher';
import {SellerSwitcher} from './SellerSwitcher';
import {UserSwitcher} from './UserSwitcher';

export const ResourceSwitcher = () => {
    const ability = useAbility(RootAbility);

    if (ability.isSeller() || ability.isSelfServe()) return <SellerSwitcher />;
    if (ability.isAdmin()) {
        return (
            <>
                <UserSwitcher />
                <ImpersonatedResourceSwitcher />
            </>
        );
    }
    return null;
};
